import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
import type { Commit } from "vuex";
import type { Params } from "@/types/api";

interface MailHistoryState {
  totalEmailsAnalyzed: number;
  totalIncidents: number;
}

const mailHistory = (): MailHistoryState => {
  return {
    totalEmailsAnalyzed: 0,
    totalIncidents: 0,
  };
};
const state = mailHistory();

const getters = {
  totalEmailsAnalyzed: (state: MailHistoryState) => state.totalEmailsAnalyzed,
  totalIncidents: (state: MailHistoryState) => state.totalIncidents,
};

const actions = {
  async getTotalEmailsAnalyzed(
    { commit }: { commit: Commit },
    { organisationId, params }: { organisationId: string; params: Params },
  ) {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get<{ count: number }>(
      `${getApiClientUrl()}/v3/pt/history/${organisationId}/messages/count?${filterParams.toString()}`,
    );
    commit("setTotalEmailsAnalyzed", res.data.count);
  },

  async getTotalIncidents(
    { commit }: { commit: Commit },
    { organisationId, params }: { organisationId: string; params: Params },
  ) {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get<{ count: number }>(
      `${getApiClientUrl()}/v3/pt/history/${organisationId}/incidents/count?${filterParams.toString()}`,
    );
    commit("setTotalIncidents", res.data.count);
  },
};

const mutations = {
  setTotalEmailsAnalyzed: (state: MailHistoryState, count: number) => {
    state.totalEmailsAnalyzed = count;
  },
  setTotalIncidents: (state: MailHistoryState, count: number) => {
    state.totalIncidents = count;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
